import PropTypes from 'prop-types'

/**
 * @typedef {object} Position
 * @property {number} latitude
 * @property {number} longitude
 */
export const positionPropType = PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired
})
